import { Classification } from '@/api/domains/classifications.types';

export const getClassificationName = (value: Classification | null) =>
  value ? `${value.name} - ${value.description}` : '';
